import { FileModel } from '@/models/file'
import { ForumChatState, ForumChatType } from '@/common/enums'

export class ForumChatModel {
  constructor(chatData = {}) {
    const {
      id,
      name,
      type,
      image,
      isMemberAnonymous,
      isMembersAbleThreadCreate,
      isProfileSetupEnabled,
      quantAgeSetting,
      state,
      teamId,
      description,
      cloneChatId,
      meta,
      objectiveFiles
    } = chatData

    const { memberCount, threadCount } = meta || {}

    this.id = id || null
    this.name = name || ''
    this.type = type || 10
    this.image = image || null
    this.teamId = teamId || null
    this.isMemberAnonymous = isMemberAnonymous || false
    this.isMembersAbleThreadCreate = isMembersAbleThreadCreate || false
    this.isProfileSetupEnabled = isProfileSetupEnabled ?? true
    this.quantAgeSetting = quantAgeSetting || null
    this.description = description || ''
    this.state = state || 10
    this.cloneChatId = cloneChatId || null
    this.meta = {
      memberCount: memberCount || 0,
      threadCount: threadCount || 0
    }
    this.objectiveFiles = objectiveFiles || []
  }

  static parseFromApi({ chat }) {
    return new ForumChatModel({
      id: chat?.id,
      name: chat?.name,
      type: chat?.type,
      image: chat?.image ? FileModel.parseFromApi({ file: chat?.image }) : null,
      description: chat?.objective,
      teamId: chat?.team?.id,
      state: chat?.state,
      isMemberAnonymous: chat?.isMemberAnonymous,
      isMembersAbleThreadCreate: chat?.isMembersAbleThreadCreate,
      isProfileSetupEnabled: chat?.isProfileSetupEnabled,
      quantAgeSetting: chat?.quantAgeSetting,
      meta: {
        memberCount: chat?.meta?.memberCount,
        threadCount: chat?.meta?.threadCount
      },
      objectiveFiles: (chat?.objectiveFiles || [])
        .map((file) => FileModel.parseFromApi({ file }))
        .sort((a, b) => (a.order ?? a.createdAt ?? 0) - (b.order ?? b.createdAt ?? 0))
    })
  }

  setMetaFromApi({ meta }) {
    this.meta = {
      memberCount: meta?.memberCount,
      threadCount: meta?.threadCount
    }
  }

  convertToApi() {
    const {
      id,
      name,
      type,
      description,
      image,
      isMemberAnonymous,
      isMembersAbleThreadCreate,
      team,
      teamId,
      cloneChatId
    } = this
    return {
      id,
      name,
      type,
      objective: description,
      isMemberAnonymous,
      isMembersAbleThreadCreate,
      teamId: teamId || team?.id,
      imageId: image?.id || null,
      cloneChatId: cloneChatId || undefined,
      objectiveFileIdList: this.objectiveFiles?.map((f, i) => ({ id: f.id, order: i })) || undefined
    }
  }

  get isCompleted() {
    return this.state === ForumChatState.COMPLETED
  }

  get isDraft() {
    return this.state === ForumChatState.DRAFT
  }

  get isLive() {
    return this.state === ForumChatState.LIVE
  }

  get isArchived() {
    return this.state === ForumChatState.ARCHIVED
  }

  get isWechat() {
    return this.type === ForumChatType.WECHAT
  }
}
